import { render, staticRenderFns } from "./coreHub.vue?vue&type=template&id=b2b99f24"
import script from "./coreHub.vue?vue&type=script&lang=js"
export * from "./coreHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports